<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('DriverManagement.teamNumber')">
                    <el-input
                      size="mini"
                      v-model="formInline.fingerGroupId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.teamName')">
                    <el-input
                      size="mini"
                      v-model="formInline.fingerGroupName"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item :label="$t('DriverManagement.authorizes')">
                    <el-input
                      size="mini"
                      v-model="formInline.totalCount"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item> -->
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('FINGERPRINTLIBRARYFILE_TRANSFER')"
                  type="text"
                  :disabled="selected.length == 0"
                  @click="transferTerminal"
                  >{{ $t("common.btn.transfer") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('FINGERPRINTLIBRARYFILE_EDIT')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="editTerminal"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('FINGERPRINTLIBRARYFILE_DELETE')"
                  type="text"
                  :disabled="selected.length != 1"
                  @click="deleteTerminal"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('FINGERPRINTLIBRARYFILE_ADD')"
                  type="text"
                  @click="addTerminal"
                  >{{ $t("common.btn.add") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('FINGERPRINTLIBRARYFILE_DOWN')"
                  type="text"
                  @click="down"
                  >{{ $t("common.btn.download") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="fingerGroupName"
            :label="$t('DriverManagement.teamName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.fingerGroupName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.ordinaryPersonnel') + ':'"
            :label-width="formLabelWidth"
            prop="normalList"
          >
            <el-input
              disabled
              class="fuInput"
              v-model="form.normalList"
              placeholder=""
            ></el-input>
            <el-button
              class="fuButton"
              size="small"
              icon="el-icon-plus"
              @click="getNormalDriver"
              >{{ $t("DriverManagement.form.chooseDriver") }}</el-button
            >
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.administrativeStaff') + ':'"
            :label-width="formLabelWidth"
            prop="adminList"
          >
            <el-input
              disabled
              class="fuInput"
              v-model="form.adminList"
              placeholder=""
            ></el-input>
            <el-button
              class="fuButton"
              size="small"
              icon="el-icon-plus"
              @click="getAdminDriver"
              >{{ $t("DriverManagement.form.chooseDriver") }}</el-button
            >
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$t('common.btn.add')"
        :visible.sync="dialogVisibleAddDrivre"
        width="1200px"
        :before-close="handleAddDrivreClose"
        class="addDialong"
        :close-on-click-modal="false"
      >
        <span
          ><normalTable
            ref="normalTable"
            :fingerGroupId="fingerGroupId"
            @postParam="postParam"
          ></normalTable
        ></span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisibleAddDrivre = false">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="assignment">{{
            $t("common.btn.confirm")
          }}</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :title="$t('common.btn.add')"
        :visible.sync="dialogVisibleAdminDrivre"
        width="1200px"
        :before-close="handleAdminDrivreClose"
        class="addDialong"
        :close-on-click-modal="false"
      >
        <span
          ><adminTable
            ref="adminTable"
            :fingerGroupId="fingerGroupId"
            @adminParam="adminParam"
          ></adminTable
        ></span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisibleAdminDrivre = false">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="AdminSure">{{
            $t("common.btn.confirm")
          }}</el-button>
        </span>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeTransferDia"
        class="transferDialong"
        :title="$t('DriverManagement.teamTransfer')"
        :visible.sync="dialogTransferFormVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :rules="TransferRules"
          ref="TransferForm"
          :model="TransferForm"
        >
          <el-form-item
            prop="fingerGroupId"
            :label="$t('DriverManagement.teamBelong') + ':'"
            :label-width="LabelWidth"
          >
            <el-input
              disabled
              type="textarea"
              :rows="2"
              size="small"
              v-model="TransferForm.fingerGroupId"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="roleId"
            :label="$t('BatteryFile.roleId') + ':'"
            :label-width="LabelWidth"
          >
            <el-scrollbar>
              <tree :isSearch="isSearch" @nodeClick="changeClick"></tree>
            </el-scrollbar>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleTransfer('TransferForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitTransferForm('TransferForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        width="1200px"
        :before-close="closeOperateDia"
        class="tableDialong"
        :title="$t('common.btn.operate')"
        :visible.sync="dialogOperateFormVisible"
        :close-on-click-modal="false"
      >
        <el-row>
          <el-col style="padding: 0 10px; box-sizing: border-box" :span="12">
            <div class="zMsgTable">
              <div>{{ $t("DriverManagement.adminList") }}</div>
              <i-table
                :list="adminList"
                :height="authorizeHeight"
                :options="authorizeOption"
                :columns="authorizeColumns"
                :operates="authorizeOperates"
              ></i-table>
            </div>
          </el-col>
          <el-col style="padding: 0 10px; box-sizing: border-box" :span="12">
            <div class="zMsgTable">
              <div>{{ $t("DriverManagement.normalList") }}</div>
              <i-table
                :list="normalList"
                :height="authorizeHeight"
                :options="authorizeOption"
                :columns="authorizeColumns"
                :operates="authorizeOperates"
              ></i-table>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FingerprintLibraryFile from "./FingerprintLibraryFile.js";
export default FingerprintLibraryFile;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
